import PropTypes from 'prop-types';
import MillesimaLink from '@/components/common/MillesimaLink';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { ESPOT_TYPE } from '@/constants/espot';

export const HtmlESpot = ({ data }) => {
	const { htmlContent, htmlContentMobile } = data;
	const isMobile = useScreenSizeContext().isMobile;
	const innerHtml = isMobile && htmlContentMobile ? htmlContentMobile : htmlContent;

	return data.type === ESPOT_TYPE.HTML_WITH_LINK ? (
		<MillesimaLink href={data.url} innerHtml={innerHtml} isWithoutContainer isNofollow={data.isNofollow} />
	) : (
		<div dangerouslySetInnerHTML={{ __html: innerHtml }} data-test-id="espot-html" data-rbf="espot-html" />
	);
};

HtmlESpot.propTypes = {
	data: PropTypes.shape({
		type: PropTypes.string.isRequired,
		htmlContent: PropTypes.string.isRequired,
		htmlContentMobile: PropTypes.string,
		url: PropTypes.string,
		isNofollow: PropTypes.bool,
	}).isRequired,
};

export default HtmlESpot;
